import { OVERVIEW_BALANCES_LOAD_TIMEOUT } from '@/core/constants/overview'
import { MutableRefObject } from 'react'

export const setBalancesTimeout = (ref: MutableRefObject<boolean>): ReturnType<typeof setTimeout> => {
  return setTimeout(() => {
    ref.current = true
  }, OVERVIEW_BALANCES_LOAD_TIMEOUT)
}
